import { Routes, RouterModule } from '@angular/router';
import { AlmConfigurationScreenComponent } from './alm-configuration.component';

const almConfigurationRoutes: Routes = [
];

export const AlmConfigurationRouter = RouterModule.forChild(almConfigurationRoutes);